/**
 * Returns the best Steam profile URL for a player.
 * Uses the stored profile_url from Steam API if available (handles custom URLs),
 * otherwise falls back to the Steam64 ID URL.
 */
export function steamProfileUrl(player) {
  if (player?.profile_url) return player.profile_url;
  if (player?.steam_id) return `https://steamcommunity.com/profiles/${player.steam_id}`;
  return null;
}
